import React from 'react';
import { useTranslation } from "react-i18next";
import DevImg from './../../custom/devImg';

const Izvestaji = () =>{
  const { t } = useTranslation();
    
return (
    <div className="Izvestaji">
    <DevImg/>
    </div>
  );
};

export default Izvestaji;